import { Grid } from "@mui/material";
import { HelpPanel } from "components/HelpPanel/HelpPanel";
import { AchievementFEFormat } from "types/achievements";
import { AchievementStepsUnion } from "types/stepper";
import { BasicInfoSummary } from "./BasicInfoSummary";
import { RulesSummary } from "./RulesSummary";

interface Props {
  errors?: any;
  data: AchievementFEFormat;
  skipToStep: (id: AchievementStepsUnion) => void;
}

export const Summary = (props: Props) => (
  <Grid container spacing={12}>
    <Grid item xs={8}>
      <BasicInfoSummary {...props} />
      <RulesSummary {...props} />
    </Grid>
    <Grid item xs={4}>
      <HelpPanel
        title="achievementActivation"
        description="achievementActivationHelpInfo"
        warnBoxText="achievementActivationWarnInfo"
      />
      <HelpPanel
        title="friendlyReminder"
        description="friendlyReminderHelpInfo"
      />
    </Grid>
  </Grid>
);
